import { Button } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import { TableController } from "./TableController";

export const TableFooter = ApplicationView(({ colSpan }: { colSpan: number }) => {
  const controller = TableController.use();
  const { items } = controller.state;
  const { filteredItems } = controller;
  const paginationEnabled = controller.paginationEnabled;
  const pageSize = controller.state.pageSize ?? 0;
  const currentPage = controller.state.currentPage ?? 1;
  const totalPages = controller.totalPages;
  const total = filteredItems.length;
  const start = paginationEnabled ? (currentPage - 1) * pageSize + 1 : 1;
  const end = paginationEnabled ? Math.min(currentPage * pageSize, total) : total;

  return (
    <tfoot>
      <tr>
        <td
          colSpan={colSpan}
          className="border-t border-slate-300 bg-slate-50/40 px-4 py-3 text-sm text-gray-500"
        >
          <div className="flex w-full flex-wrap items-center justify-between gap-2">
            <div className="flex items-center gap-3">
              <span>
                {paginationEnabled
                  ? `Showing ${start}–${end} of ${total}`
                  : `${total} of ${items.length} shown`}
              </span>
              {paginationEnabled && (
                <span className="flex items-center gap-1">
                  <Button
                    kind="link"
                    className="text-blue-500 disabled:opacity-50"
                    onClick={() => controller.actionSetPage(currentPage - 1)}
                    disabled={currentPage <= 1}
                  >
                    Previous
                  </Button>
                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <Button
                    kind="link"
                    className="text-blue-500 disabled:opacity-50"
                    onClick={() => controller.actionSetPage(currentPage + 1)}
                    disabled={currentPage >= totalPages}
                  >
                    Next
                  </Button>
                </span>
              )}
            </div>
            {controller.hasFilters && (
              <Button kind="link" className="text-blue-500" onClick={() => controller.actionClearFilters()}>
                Clear filters
              </Button>
            )}
          </div>
        </td>
      </tr>
    </tfoot>
  );
});
